// Initialize the dataLayer
window.dataLayer = window.dataLayer || [];

// Create the gtag function that pushes to the dataLayer
function gtag() {
  dataLayer.push(arguments);
}

// Set consent defaults based on stored preferences
gtag('consent', 'default', {
  analytics_storage: localStorage.getItem('silktideCookieChoice_analytical') === 'true' ? 'granted' : 'denied',
  ad_storage: localStorage.getItem('silktideCookieChoice_advertising') === 'true' ? 'granted' : 'denied',
  ad_user_data: localStorage.getItem('silktideCookieChoice_advertising') === 'true' ? 'granted' : 'denied',
  ad_personalization: localStorage.getItem('silktideCookieChoice_advertising') === 'true' ? 'granted' : 'denied',
  functionality_storage: localStorage.getItem('silktideCookieChoice_necessary') === 'true' ? 'granted' : 'denied',
  security_storage: localStorage.getItem('silktideCookieChoice_necessary') === 'true' ? 'granted' : 'denied'
});

// Configure the consent banner (skip for admin pages, and inside the mobile
// app's web view, which asks for consent natively and loads no tag manager)
const isAdminPage = window.location.pathname.startsWith('/admin') || window.location.host.includes('admin')
const isMobileApp = document.documentElement.dataset.client === 'mobile-app'
if (typeof window.silktideCookieBannerManager !== 'undefined' && !isAdminPage && !isMobileApp) {
  window.silktideCookieBannerManager.updateCookieBannerConfig({
    background: {
      showBackground: true
    },
    cookieTypes: [
      {
        id: "necessary",
        name: "Necessary",
        description: "<p>These cookies are necessary for the website to function properly and cannot be switched off. They help with things like logging in and setting your privacy preferences.</p>",
        required: true,
        onAccept: function() {
          console.log('Necessary cookies accepted');
        }
      },
      {
        id: "analytical",
        name: "Analytical",
        description: "<p>These cookies help us improve the site by tracking which pages are most popular and how visitors move around the site.</p>",
        required: false,
        onAccept: function() {
          gtag('consent', 'update', {
            analytics_storage: 'granted',
          });
          dataLayer.push({
            'event': 'consent_accepted_analytical',
          });
        },
        onReject: function() {
          gtag('consent', 'update', {
            analytics_storage: 'denied',
          });
        }
      },
      {
        id: "advertising",
        name: "Advertising",
        description: "<p>These cookies provide extra features and personalization to improve your experience. They may be set by us or by partners whose services we use.</p>",
        required: false,
        onAccept: function() {
          gtag('consent', 'update', {
            ad_storage: 'granted',
            ad_user_data: 'granted',
            ad_personalization: 'granted',
          });
          dataLayer.push({
            'event': 'consent_accepted_advertising',
          });
        },
        onReject: function() {
          gtag('consent', 'update', {
            ad_storage: 'denied',
            ad_user_data: 'denied',
            ad_personalization: 'denied',
          });
        }
      }
    ],
    text: {
      banner: {
        description: "<p>We use cookies on our site to enhance your user experience, provide personalised content, and analyse our traffic. <a href=\"https://norden.farm/privacy\" target=\"_blank\">Privacy Policy.</a></p>",
        acceptAllButtonText: "Accept all",
        acceptAllButtonAccessibleLabel: "Accept all cookies",
        rejectNonEssentialButtonText: "Reject non-essential",
        rejectNonEssentialButtonAccessibleLabel: "Reject non-essential",
        preferencesButtonText: "Preferences",
        preferencesButtonAccessibleLabel: "Toggle preferences"
      },
      preferences: {
        title: "Customize your cookie preferences",
        description: "<p>We respect your right to privacy. You can choose not to allow some types of cookies. Your cookie preferences will apply across our website.</p>",
        creditLinkText: "Get this banner for free",
        creditLinkAccessibleLabel: "Get this banner for free"
      }
    },
    position: {
      banner: "bottomLeft"
    }
  });
}